import { takeLatest, call, put } from 'redux-saga/effects'
import {
    addEmployeeAPI, employeeAddAvailabilityAPI, employeeAttendanceListAPI, employeeAvailabilityListAPI,
    employeeClockInAPI, employeeClockOutAPI, employeeDetailAPI, employeeListAPI,
    employeeUpdateAvailabilityAPI, removeEmployeeFromBusinessAPI, employeeUpdateDetailsAPI,
    employeeDashboardDataAPI, employeeLoginCodeCheckAPI, employeeAttendanceCheckAPI
} from '../api-requests/employee';
import {
    addEmployeeAvailabilityRequestError, addEmployeeAvailabilityRequestSuccess, addEmployeeRequestError,
    addEmployeeRequestSuccess, employeeAttendanceListRequestError, employeeAttendanceListRequestSuccess,
    employeeAvailabilityListRequestError, employeeAvailabilityListRequestSuccess, employeeClockInRequestError,
    employeeClockInRequestSuccess, employeeClockOutRequestError, employeeClockOutRequestSuccess,
    employeeDetailRequestError, employeeDetailRequestSuccess, employeeListRequestError,
    employeeListRequestSuccess, employeeUpdateDetailsRequestError, employeeUpdateDetailsRequestSuccess,
    updateEmployeeAvailabilityRequestError, updateEmployeeAvailabilityRequestSuccess,
    removeEmployeeFromBusinessRequestError, removeEmployeeFromBusinessRequestSuccess,
    employeeDashboardRequestError, employeeDashboardRequestSuccess, employeeLoginCodeCheckRequestError,
    employeeLoginCodeCheckRequestSuccess, employeeAttendanceCheckRequestError,
    employeeAttendanceCheckRequestSuccess
} from './employee.action';
import { EmployeeActionTypes } from './employee.types'
import { displayConsoleLog } from '../../utils/Utils'
import { decryptResponseData } from '../../utils/DataDecryptionUtils';

function* handleEmployeeAttendanceCheck({ payload }) {
    try {
        const response = yield call(employeeAttendanceCheckAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(employeeAttendanceCheckRequestSuccess(decryptedData))
            } else {
                yield put(employeeAttendanceCheckRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(employeeAttendanceCheckRequestError(error.response.data))
    }
}

export function* employeeAttendanceCheckReq() {
    yield takeLatest(EmployeeActionTypes.EMPLOYEE_ATTENDANCE_CHECK_REQUEST, handleEmployeeAttendanceCheck)
}

function* handleEmployeeLoginCodeCheck({ payload }) {
    try {
        const response = yield call(employeeLoginCodeCheckAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(employeeLoginCodeCheckRequestSuccess(decryptedData))
            } else {
                yield put(employeeLoginCodeCheckRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(employeeLoginCodeCheckRequestError(error.response.data))
    }
}

export function* employeeLoginCodeCheckReq() {
    yield takeLatest(EmployeeActionTypes.LOGIN_CODE_CHECK_REQUEST, handleEmployeeLoginCodeCheck)
}

function* handleEmployeeDashboardData({ payload }) {
    try {
        const response = yield call(employeeDashboardDataAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(employeeDashboardRequestSuccess(decryptedData))
            } else {
                yield put(employeeDashboardRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(employeeDashboardRequestError(error.response.data))
    }
}

export function* employeeDashboardDataReq() {
    yield takeLatest(EmployeeActionTypes.EMPLOYEE_DASHBOARD_DATA_REQUEST, handleEmployeeDashboardData)
}

function* handleRemoveEmployeeFromBusiness({ payload }) {
    try {
        const response = yield call(removeEmployeeFromBusinessAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(removeEmployeeFromBusinessRequestSuccess(decryptedData))
            } else {
                yield put(removeEmployeeFromBusinessRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(removeEmployeeFromBusinessRequestError(error.response.data))
    }
}

export function* removeEmployeeFromBusinessReq() {
    yield takeLatest(EmployeeActionTypes.REMOVE_FROM_BUSINESS_REQUEST, handleRemoveEmployeeFromBusiness)
}

function* handleEmployeeUpdateDetails({ payload }) {
    try {
        const response = yield call(employeeUpdateDetailsAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(employeeUpdateDetailsRequestSuccess(decryptedData))
            } else {
                yield put(employeeUpdateDetailsRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(employeeUpdateDetailsRequestError(error.response.data))
    }
}

export function* employeeUpdateDetailsReq() {
    yield takeLatest(EmployeeActionTypes.EMPLOYEE_UPDATE_DETAILS_REQUEST, handleEmployeeUpdateDetails)
}

function* handleEmployeeUpdateAvailability({ payload }) {
    try {
        const response = yield call(employeeUpdateAvailabilityAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(updateEmployeeAvailabilityRequestSuccess(decryptedData))
            } else {
                yield put(updateEmployeeAvailabilityRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(updateEmployeeAvailabilityRequestError(error.response.data))
    }
}

export function* employeeUpdateAvailabilityReq() {
    yield takeLatest(EmployeeActionTypes.UPDATE_AVAILABILITY_REQUEST, handleEmployeeUpdateAvailability)
}

function* handleEmployeeList({ payload }) {
    try {
        const response = yield call(employeeListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(employeeListRequestSuccess(decryptedData))
            } else {
                yield put(employeeListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(employeeListRequestError(error.response.data))
    }
}

export function* employeeListReq() {
    yield takeLatest(EmployeeActionTypes.EMPLOYEE_LIST_REQUEST, handleEmployeeList)
}

function* handleEmployeeDetail({ payload }) {
    try {
        const response = yield call(employeeDetailAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(employeeDetailRequestSuccess(decryptedData))
            } else {
                yield put(employeeDetailRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(employeeDetailRequestError(error.response.data))
    }
}

export function* employeeDetailReq() {
    yield takeLatest(EmployeeActionTypes.EMPLOYEE_DETAIL_REQUEST, handleEmployeeDetail)
}

function* handleEmployeeClockOut({ payload }) {
    try {
        const response = yield call(employeeClockOutAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(employeeClockOutRequestSuccess(decryptedData))
            } else {
                yield put(employeeClockOutRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(employeeClockOutRequestError(error.response.data))
    }
}

export function* employeeClockOutReq() {
    yield takeLatest(EmployeeActionTypes.CLOCK_OUT_REQUEST, handleEmployeeClockOut)
}

function* handleEmployeeClockIn({ payload }) {
    try {
        const response = yield call(employeeClockInAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(employeeClockInRequestSuccess(decryptedData))
            } else {
                yield put(employeeClockInRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(employeeClockInRequestError(error.response.data))
    }
}

export function* employeeClockInReq() {
    yield takeLatest(EmployeeActionTypes.CLOCK_IN_REQUEST, handleEmployeeClockIn)
}

function* handleEmployeeAvailabilityList({ payload }) {
    try {
        const response = yield call(employeeAvailabilityListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(employeeAvailabilityListRequestSuccess(decryptedData))
            } else {
                yield put(employeeAvailabilityListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(employeeAvailabilityListRequestError(error.response.data))
    }
}

export function* employeeAvailabilityListReq() {
    yield takeLatest(EmployeeActionTypes.AVAILABILITY_LIST_REQUEST, handleEmployeeAvailabilityList)
}

function* handleEmployeeAttendanceList({ payload }) {
    try {
        const response = yield call(employeeAttendanceListAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(employeeAttendanceListRequestSuccess(decryptedData))
            } else {
                yield put(employeeAttendanceListRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(employeeAttendanceListRequestError(error.response.data))
    }
}

export function* employeeAttendanceListReq() {
    yield takeLatest(EmployeeActionTypes.EMPLOYEE_ATTENDANCE_LIST_REQUEST, handleEmployeeAttendanceList)
}

function* handleAddEmployeeAvailability({ payload }) {
    try {
        const response = yield call(employeeAddAvailabilityAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(addEmployeeAvailabilityRequestSuccess(decryptedData))
            } else {
                yield put(addEmployeeAvailabilityRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error.response.data)
        yield put(addEmployeeAvailabilityRequestError(error.response.data))
    }
}

export function* addEmployeeAvailabilityReq() {
    yield takeLatest(EmployeeActionTypes.ADD_AVAILABILITY_REQUEST, handleAddEmployeeAvailability)
}

function* handleAddEmployee({ payload }) {
    try {
        const response = yield call(addEmployeeAPI, payload);
        if (response.status >= 200 && response.status < 300) {
            const { data } = response
            const decryptedData = decryptResponseData(data)
            if (decryptedData.data !== null) {
                yield put(addEmployeeRequestSuccess(decryptedData))
            } else {
                yield put(addEmployeeRequestError(decryptedData))
            }
        } else {
            throw response
        }
    } catch (error) {
        displayConsoleLog(error)
        displayConsoleLog(error.response.data)
        yield put(addEmployeeRequestError(error.response.data))
    }
}

export function* addEmployeeReq() {
    yield takeLatest(EmployeeActionTypes.ADD_EMPLOYEE_REQUEST, handleAddEmployee)
}